/**
 * Enum for specifying the target attribute of a link, determining where the linked document will be opened.
 */
export enum Target {
  Self = "_self",  // Open the link in the same frame as it was clicked (this is default).
  Parent = "_parent",  // Open the link in the same frame as it was clicked (this is default).
  Top = "_top",  // Open the link in the same frame as it was clicked (this is default).
  Blank = "_blank" // Open the link in a new window or tab.
}
